import editableReference from "./editableReference.js";
import linkElement from "./linkElement.js";
import general from "../general.js";
import xhrModule from "../xhrModule.js";
import formResourcesManager from "./formResourcesManager.js";

// elements
import radio from "./elements/radio.js";
import input from "./elements/input.js";

var formElementCreator = function(options) {
	return {
		init: function() {
			this.wrapper = options.container;
			this.el = options.element;
			this.lang = options.currentLanguage;
			this.callback = options.callback;
			this.languages = options.languages;
			this.editableRef = options.editableRef;
			this.editableRefInt = options.editableRefInt;
			this.entity = options.entity;
			this.routeChangeSuccess = options.routeChangeSuccess;
			this.condDataCallBack = options.addToConditionalDataArrCallback;
			this.startUniform = options.startUniform;
			this.instances = options.instances;

			// find the default lang
			this.defaultLang = general.findItemWithLowestPriority(this.languages);

			// add class to parent
			if (this.el[1].property.settings.class) {
				if (this.el[1].property.settings.class.value)
					this.wrapper.classList.add(this.el[1].property.settings.class.value);
			}

			// check if this is a conditional parent
			this.conditionalParent = null;
			if (this.el[1].property.settings.isConditionalParent) {
				this.conditionalParent = this.el[1].property.settings.isConditionalParent.value;
			}

			var editableReferenceNamePrefix = "";
			if (this.editableRef) {
				editableReferenceNamePrefix =
					"editableReferences." + this.editableRefInt + ".";
			}

			this.propertyName = this.el[1].property.name;
			if (!this.lang) {
				this.elementName =
					editableReferenceNamePrefix +
					"lang.synced.data." +
					this.propertyName +
					"." +
					"value";
			} else {
				this.elementName =
					editableReferenceNamePrefix +
					"lang." +
					this.lang.locale +
					".data." +
					this.propertyName +
					"." +
					"value";
			}

			var inputType = this.el[1].property.settings["type"].value;
			var labelTranslations = this.el[1].property.translations;
			var label = labelTranslations[Object.keys(labelTranslations)[0]].value;

			this.required = false;
			if (this.el[1].property.settings.mandatory) {
				if (this.el[1].property.settings.mandatory.value === "1")
					this.required = true;
			}

			if (this.el[1].property.settings.pattern) {
				this.pattern = this.el[1].property.settings.pattern.value;
			}

			// find our options if they are defined
			if (this.el[1].options) {
				this.options = Object.values(this.el[1].options);
				this.options.sort(function(a, b) {
					return a.priority - b.priority;
				});
			}

			// find our settings if they are defined
			if (this.el[1].property.settings) {
				this.settings = this.el[1].property.settings;
			}

			// check the value we need to prefill
			this.valueToPrefill = null;
			if (this.el[1].translations) {
				if (Object.keys(this.el[1].translations).length > 0) {
					var translations = this.el[1].translations;
					if (this.lang) {
						if (translations[this.lang.locale]) {
							this.valueToPrefill = translations[this.lang.locale].value;
						} else {
							this.valueToPrefill = null;
						}
					} else {
						this.valueToPrefill =
							translations[Object.keys(translations)[0]].value;
					}
				}
			}

			if (inputType !== "Hidden") this.createLabel(label, inputType);

			// check if we are dealing with an editable reference
			if (inputType.type) {
				inputType = inputType.type;
			}

			this.conditionalLinkData = null;
			if (this.conditionalParent && this.conditionalParent === "true") {
				var lang = null;
				if (this.lang) {
					lang = this.lang.id;
				} else {
					lang = this.defaultLang.id;
				}
				this.conditionalLinkData = {
					id: this.el[1].property.id,
					lang: lang,
					name: this.elementName
				};

				this.condDataCallBack(this.conditionalLinkData);
			}

			switch (inputType) {
				case "Textfield":
					this.createInput("text");
					break;
				case "Number":
					this.createInput("number");
					break;
				case "Password":
					this.createInput("password");
					break;
				case "Hidden":
					this.createInput("hidden");
					break;
				case "E-mail":
					this.createInput("email");
					break;
				case "Decimal":
					this.createInput("number");
					break;
				case "Date":
					this.createInput("date");
					break;
				case "Editor":
					this.createEditor();
					break;
				case "Radio":
					this.createRadio(this.options);
					break;
				case "Toggle":
					this.createCheckbox(this.options);
					break;
				case "Checkbox":
					this.createCheckbox(this.options);
					break;
				case "Select":
					this.createSelect(this.options, this.settings);
					break;
				case "Multiselect":
					this.createSelect({
						multiple: true
					});
					break;
				case "Textarea":
					this.createTextarea();
					break;
				case "Fileupload":
					this.createDropzone(this.settings);
					break;
				case "Dropzone":
					this.createDropzone(this.settings);
					break;
				case "Reference":
					this.createReference(this.settings);
					break;
				case "Editable reference":
					this.createEditableReference(this.settings);
					break;
				case "Link":
					this.createLink(this.settings);
					break;
				case "Tag":
					this.createTagField();
					break;
				default:
					this.callback(this.conditionalLinkData, this.elementName);
					console.error("type not found: ", inputType);
			}

			// this render description
			this.createDescription();
		},

		createLabel: function(label, inputType) {
			if (this.required) label = label + " *";
			var labelEl = document.createElement("label");
			var span = document.createElement("span");
			span.innerHTML = label;
			labelEl.appendChild(span);

			// add collapse toggle button in case this is the label for editable references
			if (inputType === "Editable reference") {
				var toggleBtn = document.createElement("button");
				toggleBtn.className = "btn-reference-toggle";
				toggleBtn.innerHTML = "Toggle collapse";
				labelEl.appendChild(toggleBtn);

				// add max amount to label
				if (this.el[1].property.settings.maxvalues) {
					// don't show limit when there is none
					if (this.el[1].property.settings.maxvalues.value != 0) {
						span.innerHTML =
							span.innerHTML +
							" (max. " +
							this.el[1].property.settings.maxvalues.value +
							")";
					}
				}
			}

			this.wrapper.appendChild(labelEl);
		},

		createDescription: function() {
			// check if there is a description or not
			var desc = this.el[1].property.settings.description;
			if (desc) {
				if (desc.value !== "") {
					var paragraph = document.createElement("div");
					paragraph.classList.add("description");
					paragraph.innerHTML = desc.value;
					this.wrapper.appendChild(paragraph);
				}
			}
		},

		createInput: function(inputType) {
			input({
				name: this.elementName,
				type: inputType,
				pattern: this.pattern,
				required: this.required,
				valueToPrefill: this.valueToPrefill,
				callback: this.callback,
				wrapper: this.wrapper,
				entity: this.entity,
				options: options
			}).init();

			this.callback(this.conditionalLinkData, this.elementName);
		},

		createEditor: function() {
			var textarea = document.createElement("textarea");
			textarea.setAttribute("name", this.elementName);
			textarea.classList.add("redactor-content");

			// add config if needed
			if (this.el[1].property.settings) {
				var editorSettings = {};
				if (this.el[1].property.settings.editor) {
					editorSettings = this.el[1].property.settings.editor.value;
				} else {
					editorSettings =
						'["formatting","bold","italic","underline","link","lists","image","video","html"]';
				}
				textarea.setAttribute("data-config", editorSettings);
			}
			textarea.setAttribute("tabindex", "-1");
			if (this.pattern) textarea.setAttribute("pattern", this.pattern);
			if (this.required) textarea.setAttribute("required", this.required);
			if (this.valueToPrefill) textarea.value = this.valueToPrefill;

			this.wrapper.appendChild(textarea);

			this.callback(this.conditionalLinkData, this.elementName);
		},

		createRadio: function(settings) {
			var list = document.createElement("ul");
			list.classList.add("options");

			// check if the instance already exists
			let instance = null;
			if (this.lang) {
				instance = this.getValueForThisLang(this.lang.locale);
			} else {
				instance = this.getValueForThisLang(this.defaultLang.locale);
			}

			// only set default value when there is a default defined and when there is no previous selected value to prefill
			// we also only want to show the default when we are creating a new instance
			// for older instances we want to show the user that there is no value yet
			var defaultValue = null;
			if (this.settings.defaultValue && !this.valueToPrefill && !instance)
				defaultValue = this.settings.defaultValue.value;

			var options = [];
			for (var option in settings) {
				options.push(settings[option]);
			}

			// create hidden radio so that FormData can pick up empty values
			var checkedHidden = false;
			if (!this.valueToPrefill) checkedHidden = true;
			var hiddenRadio = radio({
				checked: checkedHidden,
				value: "",
				label: "",
				name: this.elementName,
				settings: this.settings,
				defaultValue: defaultValue,
				hidden: true
			}).init();

			list.appendChild(hiddenRadio);

			for (var i = 0; i < options.length; i++) {
				var checked = false;
				if (this.valueToPrefill == options[i].value) checked = true;

				var label = null;

				if (this.lang) {
					if (options[i].translations[this.lang.locale]) {
						label = options[i].translations[this.lang.locale].value;
					}
				} else {
					if (options[i].translations[this.defaultLang.locale])
						label = options[i].translations[this.defaultLang.locale].value;
				}

				var listItem = radio({
					checked: checked,
					value: options[i].value,
					label: label,
					name: this.elementName,
					conditionalParent: this.conditionalParent,
					settings: this.settings,
					defaultValue: defaultValue
				}).init();

				list.appendChild(listItem);

				if (i === options.length - 1)
					this.callback(this.conditionalLinkData, this.elementName);
			}

			this.wrapper.appendChild(list);
		},

		createCheckbox: function(settings) {
			if (!settings || settings.length === 0) {
				this.callback(this.conditionalLinkData, this.elementName);
			}

			var isToggle = false;
			if (this.settings.type.value === "Toggle") isToggle = true;

			var list = document.createElement("ul");
			list.classList.add("options");

			var options = [];
			if (!isToggle) {
				for (var option in settings) {
					options.push(settings[option]);
				}
			} else {
				options.push({
					value: 1
				});
			}

			// this value can be an array because we could have selected mutliple values
			if (this.valueToPrefill) {
				if (this.valueToPrefill !== "") {
					try {
						this.valueToPrefill = JSON.parse(this.valueToPrefill);
					} catch (error) {}
				}
			}

			var required = false;
			if (this.settings) {
				required = this.settings.mandatory.value;
				if (required === "1") required = true;
			}

			// When no checkbox is selected there will be no data available for this input in the formData
			// To work around this we will add another checkbox with an empty value which will be auto checked when all other checkboxes have been unchecked
			// that way the server will receive an empty value in the formData.
			// Happy times :)
			var checked = false;
			if (!this.valueToPrefill) checked = true;
			var hiddenCheckbox = this.createCheckboxElement({
				checked: checked,
				value: "",
				label: "",
				hidden: true,
				required: required
			});

			list.appendChild(hiddenCheckbox);

			// create all defined checkboxes
			for (var i = 0; i < options.length; i++) {
				checked = false;

				if (this.valueToPrefill) {
					if (Array.isArray(this.valueToPrefill)) {
						var index = this.valueToPrefill.indexOf(options[i].value);
						if (index === -1)
							index = this.valueToPrefill.indexOf(options[i].value.toString());
						if (index > -1) checked = true;
					} else {
						if (options[i].value == this.valueToPrefill.toString())
							checked = true;
					}
				}

				var label = null;
				if (!isToggle) {
					if (this.lang) {
						if (options[i].translations[this.lang.locale]) {
							label = options[i].translations[this.lang.locale].value;
						}
					} else {
						label = options[i].translations[this.defaultLang.locale].value;
					}
				}

				var value = options[i].value;
				var className = "";
				if (isToggle) {
					value = 1;
					className = "toggle";
				}

				let state = 3;
				if (this.lang) {
					if (options[i].translations) {
						if (options[i].translations[this.lang.locale]) {
							if (options[i].translations[this.lang.locale].state) {
								state = options[i].translations[this.lang.locale].state;
							}
						}
					}
				}

				var checkboxEl = this.createCheckboxElement({
					checked: checked,
					value: value,
					label: label,
					class: className,
					required: required,
					state: state
				});

				list.appendChild(checkboxEl);

				if (i === options.length - 1)
					this.callback(this.conditionalLinkData, this.elementName);
			}

			this.wrapper.appendChild(list);
		},

		createCheckboxElement: function(setting) {
			var listItem = document.createElement("li");
			var label = document.createElement("label");
			label.classList.add("flex-label");
			var span = document.createElement("span");
			span.innerHTML = setting.label;

			var checkbox = document.createElement("input");
			checkbox.setAttribute("type", "checkbox");
			checkbox.setAttribute("name", this.elementName);
			if (setting.class) checkbox.classList.add(setting.class);
			if (setting.state) label.classList.add(`state-${setting.state}`);
			if (setting.required) checkbox.setAttribute("required", setting.required);

			if (setting.checked) {
				checkbox.setAttribute("checked", "");
				checkbox.checked = true;
			}

			if (setting.hidden) {
				listItem.classList.add("invisible-empty-checkbox");
				checkbox.classList.add("invisible-empty-checkbox");
			}

			checkbox.setAttribute("value", setting.value);

			if (setting.toggle) checkbox.classList.add("toggle");

			label.appendChild(checkbox);
			label.appendChild(span);
			listItem.appendChild(label);

			// Listen to changes on a checkbox so we can see if there is a value defined for this name or not
			// If not we can check the empty value checkbox
			checkbox.addEventListener(
				"change",
				this.checkboxChangedHandler.bind(this)
			);

			return listItem;
		},

		checkboxChangedHandler: function(e) {
			var target = e.currentTarget;
			var name = target.getAttribute("name");

			// get all checkboxes with this name and check which ones are checked
			var checkboxes = document.querySelectorAll('[name="' + name + '"]');
			var value = [];
			for (var i = checkboxes.length - 1; i >= 0; i--) {
				if (checkboxes[i].checked && checkboxes[i].value !== "") {
					value.push(checkboxes[i].value);
				}

				if (i === 0) {
					if (value.length > 0) {
						// set empty checkbox unchecked
						checkboxes[0].checked = false;
					} else {
						// set empty checkbox checked
						checkboxes[0].checked = true;
					}
				}
			}
		},

		createTextarea: function() {
			var textarea = document.createElement("textarea");
			textarea.setAttribute("name", this.elementName);
			if (this.pattern) textarea.setAttribute("pattern", this.pattern);
			if (this.required) textarea.setAttribute("required", this.required);
			if (this.valueToPrefill) textarea.value = this.valueToPrefill;

			this.wrapper.appendChild(textarea);

			this.callback(this.conditionalLinkData, this.elementName);
		},

		createSelect: function(options, settings) {
			var selector = document.createElement("div");
			selector.classList.add("selector");

			var select = document.createElement("select");
			select.setAttribute("name", this.elementName);

			if (options) {
				for (var option in options) {
					var optionEL = this.createSelectEl(options[option]);
					select.appendChild(optionEL);
				}
				this.selectCreated(selector, select);
			} else if (settings.endpoint) {
				var url = settings.endpoint.value;
				xhrModule.get(
					url,
					function(data) {
						var endpointOptions = data.data;

						// create empty option
						var emptyOption = document.createElement("option");
						emptyOption.value = "";
						select.appendChild(emptyOption);

						for (var i = endpointOptions.length - 1; i >= 0; i--) {
							var optionEl = document.createElement("option");
							var label = endpointOptions[i].label || endpointOptions[i].value;
							optionEl.innerHTML = label;
							optionEl.setAttribute("value", endpointOptions[i].value);
							select.appendChild(optionEl);
						}

						this.selectCreated(selector, select);
					}.bind(this)
				);
			}
		},

		selectCreated: function(selector, select) {
			selector.appendChild(select);
			this.wrapper.appendChild(selector);
			this.callback(this.conditionalLinkData, this.elementName);

			if (this.required) select.setAttribute("required", this.required);
			if (this.valueToPrefill) select.value = this.valueToPrefill;
		},

		createSelectEl: function(option) {
			var optionEl = document.createElement("option");
			var optionName = "";
			if (!this.lang) {
				optionName = option.translations[this.defaultLang.locale].value;
			} else {
				if (option.translations[this.lang.locale]) {
					optionName = option.translations[this.lang.locale].value;
				}
			}
			optionEl.innerHTML = optionName;
			optionEl.setAttribute("value", option.value);
			return optionEl;
		},

		createDropzone: function(settings) {
			// create the input field where dropzone will post the names of the files in
			var imageNamesField = document.createElement("input");
			imageNamesField.setAttribute("type", "hidden");
			imageNamesField.setAttribute("name", this.elementName);
			imageNamesField.classList.add("hidden-image-values");
			if (this.required)
				imageNamesField.setAttribute("required", this.required);

			if (this.valueToPrefill) {
				let values = "";
				if (Array.isArray(this.valueToPrefill)) {
					values = JSON.stringify(this.valueToPrefill);
				} else {
					values = this.valueToPrefill;
				}

				// if the value is an empty array we can just return nothing to prevent stringifying the empty array when saving
				if (values === "[]") values = "";

				imageNamesField.value = values;
			}

			var dropzone = document.createElement("div");
			dropzone.classList.add("dropzone-previews");

			var locale = null;
			if (this.lang) locale = this.lang.locale;

			// defaults
			var maxFileSize = 5;
			if (settings.maxfilesize) maxFileSize = settings.maxfilesize.value;
			var acceptedFiles = "[]";
			if (settings.filetype) acceptedFiles = settings.filetype.value;

			var fileSettings = {
				parallelUploads: 100,
				maxFiles: settings.maxvalues.value,
				maxFilesize: maxFileSize,
				acceptedFiles: acceptedFiles,
				entityName: this.entity.name,
				inputFieldName: this.elementName,
				predefinedValue: this.valueToPrefill,
				required: this.required,
				locale: locale,
				propertyName: this.el[0]
			};

			fileSettings = JSON.stringify(fileSettings);
			dropzone.setAttribute("data-config", fileSettings);
			this.wrapper.appendChild(imageNamesField);
			this.wrapper.appendChild(dropzone);

			this.callback(this.conditionalLinkData, this.elementName);
		},

		createReference: function(settings) {
			// references can render as select, checkbox or radio
			this.fieldToRender = settings.reference.value;
			this.referenceID = settings.referenceId.value;
			this.referenceFieldID = settings.referenceFieldId.value;

			var entities = formResourcesManager.entities;
			this.entitiesCallbackCompleted(entities);
		},

		entitiesCallbackCompleted: function(data) {
			var entities = data;
			// find the name of our entity
			for (var entity in entities) {
				if (entities[entity].id == this.referenceID) {
					// find the machine name of the field we are referencing
					var props = entities[entity].properties;
					this.referenceFieldName = null;
					for (var prop in props) {
						if (this.referenceFieldID == props[prop].id) {
							this.referenceFieldName = props[prop].name;

							// get all values and filter out the correct language and property
							var url =
								"/cms/api/instances/ofEntity?entity=" + entities[entity].id;
							formResourcesManager.fetchOtherEndpoints(
								this.referenceCallbackCompleted.bind(this),
								url
							);
						}
					}
				}
			}
		},

		referenceCallbackCompleted: function(data) {
			var langID = null;
			this.lang ? (langID = this.lang.id) : (langID = this.defaultLang.id);

			var locale = null;
			this.lang
				? (locale = this.lang.locale)
				: (locale = this.defaultLang.locale);

			// format the data into a list
			let items = data.data;
			let list = {};
			for (var i = items.length - 1; i >= 0; i--) {
				if (items[i].market !== langID) continue;
				list[items[i].uuid] = {
					value: items[i].properties[this.referenceFieldName],
					state: items[i].state
				};
			}

			// Helper function for the alphabetical sorting of the result array
			var helperDiv = document.createElement("div");
			var translationValue = v => {
				helperDiv.innerHTML = v.translations[locale].value;
				return helperDiv.textContent.trim();
			};

			// Transform and sort API-response
			// Because, apparently, we want to list references alphabetically even when they are user-sortable
			var filteredForLang = Object.keys(list)
				.reduce((a, e) => {
					if (this.referenceID === 25) {
						// Omit admin and unauthenticated roles from the results
						if (
							[
								"11EA997CE21A8EA7AC16005056982405",
								"11EAA96C12CE06A4AC16005056982405"
							].indexOf(e) < 0
						) {
							return a;
						}
					}

					let translation = list[e].value;
					if (!translation) translation = "Not translated";

					a.push({
						id: e,
						value: e,
						translations: {
							[locale]: {
								value: translation,
								state: list[e].state
							}
						}
					});

					return a;
				}, [])
				.sort((a, b) => translationValue(a).localeCompare(translationValue(b)));

			if (filteredForLang.length > 0) {
				// prepare empty value
				var emptyVal = JSON.parse(JSON.stringify(filteredForLang[0]));
				emptyVal.id = "";
				emptyVal.value = "";
				emptyVal.translations[locale].value = "None";
			}

			if (!filteredForLang || filteredForLang.length === 0)
				this.callback(this.conditionalLinkData, this.elementName);

			// decide which element to render
			switch (this.fieldToRender) {
				case "select":
					// add empty value at the top
					if (emptyVal) filteredForLang.unshift(emptyVal);
					this.createSelect(filteredForLang);
					break;
				case "checkbox":
					this.createCheckbox(filteredForLang);
					break;
				case "radio":
					if (!this.required) {
						// add empty value at the top
						if (emptyVal) filteredForLang.unshift(emptyVal);
					}

					this.createRadio(filteredForLang);
					break;
			}
		},

		createEditableReference: function(settings) {
			editableReference({
				mainContainer: this.wrapper,
				settings: settings,
				callback: this.callback,
				languages: this.languages,
				currentLang: this.lang,
				uuid: this.valueToPrefill,
				routeChangeSuccess: this.routeChangeSuccess,
				defaultLang: this.defaultLang,
				startUniform: this.startUniform
			}).init();
		},

		createLink: function(settings) {
			linkElement({
				mainContainer: this.wrapper,
				callback: this.callback,
				settings: this.settings,
				value: this.valueToPrefill,
				name: this.elementName,
				currentLang: this.lang
			}).init();
		},

		createTagField: function() {
			var options = ["None", "Tag"];
			var formattedOptions = [];

			for (var i = 0; i < options.length; i++) {
				var option = {
					translations: {},
					value: options[i]
				};

				for (var lang in this.languages) {
					option.translations[this.languages[lang].locale] = {};
					option.translations[this.languages[lang].locale].value = options[i];
				}

				formattedOptions.push(option);

				if (i === options.length - 1) {
					this.createRadio(formattedOptions);
				}
			}
		},

		getValueForThisLang: function(locale) {
			for (var key in this.instances) {
				if (this.instances[key].market.locale === locale) {
					return this.instances[key];
				}
			}
		}
	};
};

export default formElementCreator;
